import {
  Icon,
  Panel,
  SageClassnames,
  useSageBreakpoint,
  Card,
  SageTokens,
  Tooltip,
} from '@kajabi/sage-react';
import BusinessPreviewSubPanelRow from './BusinessPreviewSubPanelRow';
import {
  SALES_EMAIL_ID,
  SALES_EMAIL_TOOLTIP_COPY,
} from '../../../utils/constants';

interface PropTypes {
  handleClick: (component: string) => void;
  icon: string;
  color: string;
  text: string;
  id: string;
  selected: string;
}

const BusinessPreviewSlideTab = ({
  handleClick,
  icon,
  color,
  text,
  id,
  selected,
}: PropTypes) => {
  const breakpoints = useSageBreakpoint();

  if (breakpoints.md) {
    return (
      <Card
        key={id}
        style={{
          width: '165px',
          border: selected === id ? '2px solid black' : null,
          height: '52px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor:
            selected === id ? SageTokens.COLOR_PALETTE.GREY_200 : null,
        }}
        onClick={() => handleClick(id)}
      >
        <p
          className={SageClassnames.TYPE.BODY_MED}
          style={{ textAlign: 'center' }}
        >
          {text}
        </p>
      </Card>
    );
  }

  return (
    <Panel
      key={id}
      style={{
        padding: '16px',
        width: '420px',
        border: selected === id ? '2px solid black' : null,
        backgroundColor:
          selected === id ? SageTokens.COLOR_PALETTE.GREY_200 : null,
      }}
      onClick={() => handleClick(id)}
    >
      <Panel.Row gridTemplate="sm">
        <Icon
          backgroundHeight="56px"
          backgroundWidth="56px"
          icon={icon}
          cardColor={color}
          size="xl"
        />
        <p className={SageClassnames.TYPE.BODY_MED}>{text}</p>
        {id === SALES_EMAIL_ID ? (
          <Tooltip
            content={
              <p className={SageClassnames.TYPE.BODY_SMALL}>
                {SALES_EMAIL_TOOLTIP_COPY}
              </p>
            }
            position={Tooltip.POSITIONS.RIGHT}
          >
            <Icon
              style={{ marginLeft: '-15px', marginBottom: '8px' }}
              icon={SageTokens.ICONS.INFO_CIRCLE}
            />
          </Tooltip>
        ) : (
          <></>
        )}
      </Panel.Row>
      {id === 'landing_page' && <BusinessPreviewSubPanelRow />}
    </Panel>
  );
};

export default BusinessPreviewSlideTab;
